import { Controller } from '@hotwired/stimulus';

const GUTTER = 16;

// Shifts an open bubble back inside the viewport; the arrow moves the other way to stay on the icon.
export default class extends Controller {
  static targets = ['bubble'];

  fit() {
    const bubble = this.bubbleTarget;
    bubble.style.removeProperty('--tip-shift');
    const { left, right, width } = bubble.getBoundingClientRect();
    if (!width) return;

    const viewport = document.documentElement.clientWidth;
    const shift = Math.max(
      GUTTER - left,
      Math.min(0, viewport - GUTTER - right),
    );
    if (shift) bubble.style.setProperty('--tip-shift', `${shift}px`);
  }
}
